export default "__VITE_ASSET__CwyKT7uQ__"